import React from "react";
import {Card, CardContent, CardHeader, Container} from "@mui/material";
import { object, string, number, boolean, date, coerce } from 'zod';
import {formatDateTime, formatDateTimeParam, formatDate, formatTime} from "../../../../utils/formatDate.ts";
import * as crudgen from "../../../../share";
import {DEBOUNCE_TIME} from "../../../../utils/constants";
import { CuttingState, CuttingStatePairs, toString as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { ShipmentState, ShipmentStatePairs, toString as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { ShipmentType, ShipmentTypePairs, toString as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { UserType, UserTypePairs, toString as toStringUserType } from "../../../types/models/UserType.d";
import { CordwoodMeasurementType, CordwoodMeasurementTypePairs, toString as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";





import { PrimaryShipment } from "../../../../timber/types/models/Shipment";

import ShipmentFormSelect from "../../../../timber/components/shipment/ShipmentForm/ShipmentFormSelect";

import { useGetShipmentQuery } from "../../../../timber/apis/Shipment.api";





































import { t, msg } from "@lingui/core/macro";
import useSearchDebounce from "../../../../hooks/useSearchDebounce";
import {useLocation} from "react-router";










export const initialFormStateFn = () => { return {
    
        
        shipmentId: null,
        
    
        
        action: "",
        
    
        
        contextHistory: "",
        
    
    }
}

export const useLocationFormState = () => {
    const initialFormState = initialFormStateFn()
    let location = useLocation();
    initialFormState.shipmentId = PrimaryShipment.fromQuery(location.state?.shipmentId) || null;
    

    const { data: shipmentIdData } = useGetShipmentQuery(PrimaryShipment.fromId(initialFormState.shipmentId), { skip: !initialFormState.shipmentId })
    

    return React.useMemo(() => initialFormState, [
        location.state,
        shipmentIdData,
        
        
    ])
}

export const formObject = {
    
    
        shipmentId:
        string()
                .nanoid(msg`Shipment is required`)
                .min(1, msg`Shipment is required`),
    
    
        action:
        string()
        .trim()
        .min(1, msg`Action is required`),
    
    
        contextHistory:
        string()
        .trim()
        .nullish(),
    
};

export const formSchema = object(formObject);

const ShipmentHistoryAddForm = ({watch, prefix = ''})  => {
    return (
        <Container>
           
           
   
    
    <ShipmentFormSelect
        type="none"
        name="shipmentId"
        label={t`Shipment`}
        prefix={prefix}
        required={ true }
    />
   
   
   
           
           
   
   <crudgen.FormInput
       required
       name={ prefix + 'action' }
       aria-label="action"
       data-testid="action"
       label={t`Action`}
       
       type='text'
       
   />
   
   
           
           
   
   <crudgen.FormInput
       
       name={ prefix + 'contextHistory' }
       aria-label="contextHistory"
       data-testid="contextHistory"
       label={t`Context History`}
       
       type='text'
       
   />
   
   
           
        </Container>
    )
}

export default ShipmentHistoryAddForm;
